import type { Locale } from '@skytech/types'

import { LEADING_ZEROS_PATTERN, ZERO_PREFIX_COUNTRY_CODES } from '@skytech/utils'

export function isOnlyLetters(val: string | number) {
  if (typeof val === 'number') return false

  return !/\d/.test(val)
}

export function isOnlyDigits(val: string | number) {
  if (typeof val === 'number') return true

  return /^[0-9]+$/.test(val)
}

export const getFormattedNumber = ({
  locale,
  amount,
  precision = 2,
}: {
  locale: Locale
  amount: number
  precision?: number
}) => amount.toLocaleString(locale, { maximumFractionDigits: precision })

export function isStringOfLength(val: string, length: number) {
  return val.length === length
}

export const trimLeadingZeros = (val: string | number) => {
  let value = typeof val === 'number' ? String(val) : val
  const trimmed = value.replace(LEADING_ZEROS_PATTERN, '')
  if (trimmed.startsWith('.')) {
    return '0' + trimmed
  }
  return trimmed || '0'
}

export const getPricePrecision = (value: number): 0 | 2 => {
  const rounded = Number(value.toFixed(2))
  return Number.isInteger(rounded) ? 0 : 2
}

export const getFormattedPhoneNumber = ({
  value,
  countryId,
}: {
  value: string
  countryId: number
}) => {
  const onlyDigits = value.replace(/\D/g, '')
  let formattedNumber = onlyDigits

  if (
    onlyDigits.length > 0 &&
    ZERO_PREFIX_COUNTRY_CODES.includes(countryId) &&
    onlyDigits[0] !== '0' // If the first number is not 0
  ) {
    formattedNumber = `0${onlyDigits}`
  } else if (onlyDigits.length > 0 && !ZERO_PREFIX_COUNTRY_CODES.includes(countryId)) {
    formattedNumber = onlyDigits.replace(/^0+/, '') // Remove leading zeros for countries that don't use them
  }
  return formattedNumber
}

export const getPricePerInstallment = (totalPrice: number, installmentCount: number) => {
  const monthlyPrice =
    installmentCount === 0 ? totalPrice : Math.max(0, totalPrice / installmentCount)
  return monthlyPrice
}
